import { accountHasOfficePermission } from '@/store/permissions';
import { mapGetters } from 'vuex';

export default {
  methods: {
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
    settlementOwnerCompanyAccount(settlement) {
      return this.findCompanyAccount()(settlement.ownerCompany.id);
    },
    settlementBilledToCompanyAccount(settlement) {
      return this.findCompanyAccount()(settlement.billedToCompanyId);
    },
    settlementCarrierCompanyAccount(settlement) {
      return this.findCompanyAccount()(settlement.truckingCompany.id);
    },
    userCanModifySettlementAmount(settlement) {
      const account = this.settlementOwnerCompanyAccount(settlement);
      return this.isLtnAdmin || accountHasOfficePermission(account);
    },
    userCanModifySettlementDeliveryDetails(settlement) {
      const account = this.settlementCarrierCompanyAccount(settlement);
      return this.isLtnAdmin || accountHasOfficePermission(account);
    },
    showSettlementUpdateButton(settlement) {
      return this.isLtnAdmin ||
             this.userCanModifySettlementAmount(settlement) ||
             this.userCanModifySettlementDeliveryDetails(settlement);
    },
  },
  computed: {
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
  },
};



// WEBPACK FOOTER //
// ./src/mixins/settlementMixin.js